import type { Language } from 'element-plus/es/locales.mjs';
import { getCurrentLanguage } from '@telecom/shared/utils/language-tool';
import type { App } from 'vue';
import ElementPlus from 'element-plus';

export async function loadElementPlusLocale(app:App) {
    const lang = getCurrentLanguage();
    const langMessages: {
        [key: string]: Promise<{ default: Language }>,
    } = {
        cn: import('element-plus/dist/locale/zh-cn.mjs'),
        en: import('element-plus/dist/locale/en.mjs'),
        jp: import('element-plus/dist/locale/ja.mjs'),
        tw: import('element-plus/dist/locale/zh-tw.mjs'),
    };

    const data = (await langMessages[lang]).default;
    app.use(ElementPlus, { locale: data });
}
